<script>
export default {
  name: 'QkCircleUserManage',
  props: ['currentUser'],
  data() {
    return {
      param: {
        size: 10,
        circle_id: 0,
        type: 'staff',
      },
      circle_id: 0,
      users: [],
      userList: [],
      searchText: '',
      composing: false,
      typingTimer: null,
      loading: false,
      isDataEmpty: false,
      locked: false,
    };
  },
  computed: {
    emptyImg() {
      return `${qk_global.home_url}/wp-content/themes/mkua/Assets/fontend/images/empty.svg`;
    },
  },
  mounted() {
    if (typeof qk_circle !== 'undefined') {
      this.circle_id = this.param.circle_id = qk_circle.id;
    }

    if (!this.userList.length) {
      this.$refs.jsonPageNav.load(1, '', true);
    }
  },
  watch: {
    searchText() {
      this.searchText = this.searchText.trim();
      if (!this.searchText) {
        this.userList = this.users;
      }
    },
  },
  methods: {
    changeUsers(data) {
      this.userList = [];
      this.users = [];
      this.userList = data.list;
      this.users = data.list;
      this.isDataEmpty = !this.userList.length;
    },
    changeuserTab(type) {
      if (this.param.type === type) return;
      this.param.type = type;
      this.userList = [];
      this.users = [];
      this.loading = true;
      this.$refs.jsonPageNav.load(1, '', true);
    },
    handleInput() {
      if (this.searchText.trim()) {
        this.userList = [];
        this.loading = true;
      }
      if (!this.composing) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(() => {
          this.circleSearchUsers();
        }, 500);
      }
    },
    circleSearchUsers() {
      if (!this.searchText.trim()) return;
      this.loading = true;
      this.$https
        .post(`${qk_rest_url}circleSearchUsers`, {
          key: this.searchText.trim(),
          circle_id: this.circle_id,
        })
        .then((res) => {
          this.userList = res.data;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          qkShowApiError(err, '搜索用户失败');
        });
    },
    inviteUserJoinCircle(user_id, index) {
      if (!confirm('确定要邀请这个用户入圈吗？')) return;
      if (this.locked) return;
      this.locked = true;

      this.$https
        .post(`${qk_rest_url}inviteUserJoinCircle`, {
          user_id,
          circle_id: this.circle_id,
        })
        .then((res) => {
          this.userList[index].in_circle = true;
          this.users[index].in_circle = true;
          this.$message({ message: res.data.msg, type: 'success' });
          this.locked = false;
        })
        .catch((err) => {
          this.locked = false;
          this.$message({ message: qkGetApiError(err, '操作失败'), type: 'error' });
        });
    },
    setUserCircleStaff(user_id, index) {
      if (!confirm('确定要设置这个用户为版主吗？')) return;
      if (this.locked) return;
      this.locked = true;

      this.$https
        .post(`${qk_rest_url}setUserCircleStaff`, {
          user_id,
          circle_id: this.circle_id,
        })
        .then((res) => {
          this.userList[index].role = 'staff';
          this.users[index].role = 'staff';
          this.$message({ message: res.data.msg, type: 'success' });
          this.locked = false;
        })
        .catch((err) => {
          this.locked = false;
          this.$message({ message: qkGetApiError(err, '操作失败'), type: 'error' });
        });
    },
    removeCircleUser(user_id, index) {
      if (!confirm('确定要移除这个用户吗？')) return;
      if (this.locked) return;
      this.locked = true;

      this.$https
        .post(`${qk_rest_url}removeCircleUser`, {
          user_id,
          circle_id: this.circle_id,
        })
        .then((res) => {
          this.userList.splice(index, 1);
          this.users.splice(index, 1);
          this.$message({ message: res.data.msg, type: 'success' });
          this.locked = false;
        })
        .catch((err) => {
          this.locked = false;
          this.$message({ message: qkGetApiError(err, '操作失败'), type: 'error' });
        });
    },
  },
};
</script>

<template>
  <div class="user-manage form-container">
    <form>
      <label class="form-item">
        <input
          v-model="searchText"
          class="input"
          type="text"
          autocomplete="off"
          maxlength="100"
          placeholder="搜索用户"
          @input="handleInput"
          @compositionstart="composing = true"
          @compositionend="composing = false"
        />
        <span class="icon"><i class="ri-search-2-line"></i></span>
        <span class="invite"><i class="ri-user-add-line"></i></span>
      </label>
    </form>
    <div v-show="!searchText" class="user-tabs">
      <ul class="tabs-nav">
        <li :class="{ active: param.type === 'staff' }" @click="changeuserTab('staff')">管理</li>
        <li :class="{ active: param.type === 'user' }" @click="changeuserTab('user')">圈友</li>
      </ul>
    </div>
    <ul v-if="userList.length" class="user-list scroll">
      <li v-for="(item, index) in userList" :key="index" class="list-item is-visible">
        <a :href="item.link" v-html="item.avatar_html"></a>
        <div class="user-info">
          <div class="user-info-name">
            <a target="_blank" class="user-name no-hover" :href="item.link">{{ item.name }}</a>
            <span v-if="item.lv.icon" class="user-lv">
              <img :src="item.lv.icon" class="lv-img-icon" />
            </span>
            <span v-if="item.vip.image" class="user-vip">
              <img :src="item.vip.image" class="vip-img-icon" />
            </span>
            <div v-if="item.role === 'admin'" class="user-circle-role">圈主</div>
            <div v-if="item.role === 'staff'" class="user-circle-role staff">版主</div>
          </div>
          <div class="desc text-ellipsis">{{ item.date ? item.date : item.desc }}</div>
        </div>
        <div
          v-if="
            (currentUser.is_circle_staff && (item.role === 'member' || !item.role)) ||
            currentUser.is_admin ||
            currentUser.is_circle_admin
          "
          class="user-action"
        >
          <span v-if="item.in_circle" class="button bg-text" @click="removeCircleUser(item.id, index)">
            移除
          </span>
          <span v-else class="button bg-text" @click="inviteUserJoinCircle(item.id, index)">邀请</span>
          <span
            v-if="
              (item.role === 'member' || !item.role) &&
              (currentUser.is_admin || currentUser.is_circle_admin)
            "
            class="button bg-text"
            @click="setUserCircleStaff(item.id, index)"
          >
            设为版主
          </span>
        </div>
      </li>
    </ul>
    <div v-else-if="loading && !userList.length" v-cloak class="loading empty"></div>
    <template v-else-if="isDataEmpty">
      <div class="empty">
        <img :src="emptyImg" class="empty-img" />
        <p class="empty-text">暂无数据</p>
      </div>
    </template>
    <div class="qk-pagenav json-nav">
      <page-nav
        ref="jsonPageNav"
        paged="1"
        pages="1"
        navtype="json"
        type="page"
        :api="'getCircleUsers'"
        :param="param"
        v-once
        @change="changeUsers"
      />
    </div>
  </div>
</template>
